import * as React from 'react';
import * as styles from './DiscountLabel.css';

export interface IDiscountLabelProps {
  discount: number | null;
}

export const DiscountLabel = (props: IDiscountLabelProps) => {
  const { discount } = props;

  if (!discount) {
    return null;
  }

  // tslint:disable-next-line: no-implicit-dependencies
  const discountIcon = require('!raw-loader!./images/discount.svg');

  return (
    <div className={styles['label_wrapper']}>
      <div
        className={styles['label']}
        dangerouslySetInnerHTML={{ __html: discountIcon }}
      />
      <div className={styles['discount']}>
        −{discount}%
      </div>
    </div>
  );
};
